<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->


<template>
<b-modal 
  :active="active" 
  @close="close()" 
  has-modal-card 
  :can-cancel="['escape', 'outside']"
  :append-to-body="appendToBody"
  v-bind="$attrs"
>
  <cytomine-modal-card :title="title" @close="close()">
    <slot></slot>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </cytomine-modal-card>
</b-modal>
</template>

<script>
import CytomineModalCard from './CytomineModalCard';

export default {
  name: 'cytomine-modal',
  inheritAttrs: false,
  props: {
    active: Boolean,
    title: String,
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  components: {CytomineModalCard},
  methods: {
    close() {
      this.$emit('close');
      this.$emit('update:active', false);
    }
  }
};
</script>
